import config from '@/config/config'
import axios from 'axios'

export default {
    state: {
        producers: [],
        groups: [],
        appointments: [],
        loadingProducers: true,
        loadingGroup: true
    },
    mutations: {
        setGaProducers (state, payload) {
            state.producers = payload
        },
        setGaGroups (state, payload) {
            state.groups = payload
        },
        setLoadingProducers (state, payload) {
            state.loadingProducers = payload
        },
        setPendingAppointments (state, payload) {
            state.appointments = payload
        }
    },
    actions: {
        getGaProducers ({commit}) {
            commit('setGaProducers', [])
            commit('setLoadingProducers', true)
            axios.get(config.apiUrl() + 'ga/getProducers').then(response => {
                commit('setGaProducers', response.data)
                commit('setLoadingProducers', false)
            }, err => {
                commit('setGaProducers', [])
                commit('setLoadingProducers', false)
            })
        },
        getGaGroups ({commit}) {
            commit('setGaGroups', [])
            axios.get(config.apiUrl() + 'ga/getGroups').then(response => {
                commit('setGaGroups', response.data)
            }, err => {
                commit('setGaGroups', [])
            })
        },
        getPendingAppointments({commit}) {
            commit('setPendingAppointments', [])
            axios.get(config.apiUrl() + 'ga/getPendingAppointments').then(response => {
                commit('setPendingAppointments', response.data)
            }, err => {
                commit('setPendingAppointments', [])
            })
        }
    },
    getters: {
        gaProducers: state => state.producers,
        gaGroups: state => state.groups,
        loadingProducers: state=> state.loadingProducers,
        pendingAppointments: state=> state.appointments
    }
}
